'use client';

import { Button, Entering, Typography } from 'components';
import {
  TRANSLATORS_SIGN_IN_LINK,
  TRANSLATORS_SIGN_UP_FACEBOOK_LINK,
  TRANSLATORS_SIGN_UP_GOOGLE_LINK,
  TRANSLATORS_SIGN_UP_LINK,
  TRANSLATORS_SIGN_UP_LINKEDIN_LINK
} from 'constants/links';
import { EmailIcon, FacebookIcon, GoogleIcon, LinkedinIcon } from 'lib/svgs/Icons';

import { useTranslations } from 'next-intl';
import Link from 'next/link';

export default function Translators() {
  const t = useTranslations();

  return (
    <>
      <div className="flex w-full flex-col gap-4 pt-8">
        <Entering initial={false} damping={20} mass={0.5} stiffness={120} delay={0.1}>
          <Link href={TRANSLATORS_SIGN_IN_LINK}>
            <Button
              size="medium"
              className="w-full !py-4"
              classNameTypography="!font-normal"
              color="white"
              startAdornment={<EmailIcon className="mr-1" />}
              label={t('auth.sign_in.sign_in_with_email')}
            />
          </Link>
        </Entering>
        <Entering initial={false} damping={20} mass={0.5} stiffness={120} delay={0.2}>
          <Link href={TRANSLATORS_SIGN_UP_GOOGLE_LINK}>
            <Button
              size="medium"
              className="w-full !py-4"
              classNameTypography="!font-normal"
              color="white"
              startAdornment={<GoogleIcon className="mr-1" />}
              label={t('auth.sign_in.sign_in_with') + ' Google'}
            />
          </Link>
        </Entering>
        <Entering initial={false} damping={20} mass={0.5} stiffness={120} delay={0.3}>
          <Link href={TRANSLATORS_SIGN_UP_FACEBOOK_LINK}>
            <Button
              size="medium"
              className="w-full !py-4"
              classNameTypography="!font-normal"
              color="white"
              startAdornment={<FacebookIcon className="mr-1" />}
              label={t('auth.sign_in.sign_in_with') + ' Facebook'}
            />
          </Link>
        </Entering>
        <Entering initial={false} damping={20} mass={0.5} stiffness={120} delay={0.4}>
          <Link href={TRANSLATORS_SIGN_UP_LINKEDIN_LINK}>
            <Button
              size="medium"
              className="w-full !py-4"
              classNameTypography="!font-normal"
              color="white"
              startAdornment={<LinkedinIcon className="mr-1" />}
              label={t('auth.sign_in.sign_in_with') + ' Linkedin'}
            />
          </Link>
        </Entering>
      </div>
      <Entering initial={false} damping={20} mass={0.5} stiffness={120} delay={0.5}>
        <div className="flex flex-col gap-6 pt-8">
          <span className="flex items-center justify-center pt-8">
            <Typography variant="light4" className="text-tertiary-200">
              {t('auth.sign_in.dont_have_account')}
            </Typography>
            <Typography variant="regular4">
              <Link
                href={TRANSLATORS_SIGN_UP_LINK}
                className="ml-1 cursor-pointer text-sm text-secondary-link"
              >
                {t('auth.sign_in.sign_up')}
              </Link>
            </Typography>
          </span>
        </div>
      </Entering>
    </>
  );
}
